import { render, staticRenderFns } from "./SearchBoxPlanoFinanceiro.vue?vue&type=template&id=6c9dd3b8&scoped=true"
import script from "./SearchBoxPlanoFinanceiro.vue?vue&type=script&lang=js"
export * from "./SearchBoxPlanoFinanceiro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../paylogos-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9dd3b8",
  null
  
)

export default component.exports